// 圖片 URL 選擇工具
// 規則：列表/縮圖顯示優先用 thumbnail，缺失時 fallback 到原圖

/** 從多個候選值中取第一個非空字串；全空回傳空字串 */
export function firstNonEmpty(...candidates: Array<string | null | undefined>): string {
  for (const c of candidates) {
    if (c && c.length > 0) return c;
  }
  return '';
}

/** Gallery / 已上傳檔案的列表縮圖 */
export function getThumbnailUrl(item: {
  imageThumbnailUrl?: string | null;
  imageUrl?: string | null;
}): string {
  return firstNonEmpty(item.imageThumbnailUrl, item.imageUrl);
}

/** Toolkit 卡片縮圖 */
export function getToolkitThumbnail(t: {
  imageThumbnailUrl?: string | null;
  image?: string | null;
}): string {
  return firstNonEmpty(t.imageThumbnailUrl, t.image);
}
